module.exports = __webpack_public_path__ + "img/step2-d.5b7d01c3.png";